import { useState } from "react";
import { NOTE_GUIDE, GUIDE_INTRO } from "../lib/noteGuide";
import {
  Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger, SheetDescription,
} from "../components/ui/sheet";
import { BookOpen, ChevronDown, Lightbulb, HelpCircle } from "lucide-react";

export default function NoteGuide() {
  const [open, setOpen] = useState(null);

  return (
    <Sheet>
      <SheetTrigger asChild>
        <button
          data-testid="open-guide-btn"
          className="flex items-center gap-2 h-10 px-4 rounded-full bg-white border border-[#E2DFD8] text-sm font-medium text-[#4A6B53] hover:border-[#4A6B53] hover:-translate-y-0.5 transition-all shadow-sm"
        >
          <BookOpen className="w-4 h-4" strokeWidth={1.5} /> Note Guide
        </button>
      </SheetTrigger>
      <SheetContent
        side="right"
        data-testid="note-guide-panel"
        className="w-full sm:max-w-md overflow-y-auto bg-[#F9F9F6] border-l border-[#E2DFD8] p-0"
      >
        <SheetHeader className="sticky top-0 z-10 bg-[#F9F9F6]/90 backdrop-blur-xl px-6 py-5 border-b border-[#E2DFD8] text-left">
          <SheetTitle className="font-display text-2xl font-extrabold tracking-tight text-[#121814] flex items-center gap-2">
            <BookOpen className="w-6 h-6 text-[#4A6B53]" strokeWidth={1.5} /> Note Guide
          </SheetTitle>
          <SheetDescription className="text-sm text-[#7A8C82] leading-relaxed mt-1">{GUIDE_INTRO}</SheetDescription>
        </SheetHeader>

        <div className="px-6 py-5 space-y-3">
          {NOTE_GUIDE.map((item, i) => {
            const isOpen = open === item.key;
            return (
              <div
                key={item.key}
                data-testid={`guide-card-${item.key}`}
                className="bg-white border border-[#E2DFD8] rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => setOpen(isOpen ? null : item.key)}
                  className="w-full flex items-center justify-between gap-3 px-4 py-3.5 text-left hover:bg-[#F4F3EF] transition-colors"
                >
                  <span className="flex items-center gap-3 min-w-0">
                    <span className="w-6 h-6 shrink-0 rounded-md bg-[#DCE5DF] text-[#4A6B53] text-xs font-bold flex items-center justify-center">
                      {i + 1}
                    </span>
                    <span className="font-semibold text-sm text-[#121814] truncate">{item.title}</span>
                  </span>
                  <ChevronDown
                    className={`w-4 h-4 text-[#7A8C82] shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`}
                    strokeWidth={1.5}
                  />
                </button>
                {isOpen && (
                  <div className="px-4 pb-4 pt-1 space-y-3 fade-up">
                    <div className="flex gap-2.5">
                      <HelpCircle className="w-4 h-4 text-[#4A6B53] shrink-0 mt-0.5" strokeWidth={1.5} />
                      <div>
                        <p className="text-[10px] font-bold text-[#7A8C82] uppercase tracking-wider">What it is</p>
                        <p className="text-sm text-[#3A453F] leading-relaxed">{item.what}</p>
                      </div>
                    </div>
                    <div className="flex gap-2.5">
                      <Lightbulb className="w-4 h-4 text-[#D4A373] shrink-0 mt-0.5" strokeWidth={1.5} />
                      <div>
                        <p className="text-[10px] font-bold text-[#7A8C82] uppercase tracking-wider">Why it matters</p>
                        <p className="text-sm text-[#3A453F] leading-relaxed">{item.why}</p>
                      </div>
                    </div>
                    <div className="rounded-lg bg-[#F4F6F3] border border-[#DCE5DF] px-3 py-2">
                      <p className="text-[10px] font-bold text-[#4A6B53] uppercase tracking-wider mb-0.5">Example</p>
                      <p className="text-sm text-[#3A453F] italic leading-relaxed">"{item.example}"</p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </SheetContent>
    </Sheet>
  );
}
